import { useEffect } from 'react';
import { collectAndRegisterDeviceProfile } from '@/lib/deviceProfile';
import { useAuth } from './useAuth';

const REGISTER_INTERVAL_MS = 6 * 60 * 60 * 1000;

let inFlightRegistration: Promise<unknown> | null = null;
let lastRegisteredAt = 0;

export function useDeviceProfileRegistration() {
  const { token, isReady } = useAuth();

  useEffect(() => {
    if (!isReady || !token) return;

    const register = () => {
      const now = Date.now();
      if (
        inFlightRegistration ||
        now - lastRegisteredAt < REGISTER_INTERVAL_MS
      ) {
        return;
      }

      inFlightRegistration = collectAndRegisterDeviceProfile(token)
        .then(() => {
          lastRegisteredAt = Date.now();
        })
        .catch((error) => {
          console.warn('[DeviceProfile] registration failed:', error);
        })
        .finally(() => {
          inFlightRegistration = null;
        });
    };

    register();
    const intervalId = window.setInterval(register, REGISTER_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, [isReady, token]);
}
